<template>
  <div class="p-todo-item">
    <div
      class="js-card p-todo-item__card p-no-selection"
      :class="{'p-todo-item__card--cursor-default' : !hasAccess()}"
      @mousedown.stop="hasAccess() ? dragStart() : null"
    >
      <div class="d-flex">
        <div class="font-weight-medium flex-grow-1">
          {{ todo.title }}
          <span v-if="todo.changed">
            <v-tooltip v-if="todo.changed" bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <span v-if="todo.changed" class="item-changed"></span>
                </v-btn>
              </template>
              {{ $t('todo.changedTooltip') }}
            </v-tooltip>
          </span>
        </div>
        <template v-if="hasAccess()">
          <div class="mt-n2">
            <p-btn-icon
              type="edit"
              @click="$emit('edit', todo)"
            ></p-btn-icon>
          </div>
          <div v-if="todo.canDelete" class="mr-n2 mt-n2">
            <todo-item-actions-menu
              :todo="todo"
              @delete="$emit('delete', todo)"
            ></todo-item-actions-menu>
          </div>
        </template>
      </div>

      <div class="p-todo-item__description">
        {{ todo.description }}
      </div>

      <v-row align="center">
        <v-col>
          <div class="p-todo-item__project">
            {{ todoMapped.project.title }}
          </div>
        </v-col>
        <v-col>
          <p-user-item
            v-for="user in todoMapped.users"
            :key="user.id"
            :value="user"
            avatar-class="mr-2"
            avatar-only
          ></p-user-item>
        </v-col>
      </v-row>

      <v-row align="center" v-if="todoMapped.deadlineFormatted">
        <v-col>
          <div class="p-todo-item__deadline">
            <v-icon>mdi-calendar-blank-outline</v-icon>
            {{ todoMapped.deadlineFormatted }}
          </div>
        </v-col>
      </v-row>

      <v-row v-if="todoMapped.attachments.length">
        <v-col>
          <div class="p-todo-item__attachments">
            <div>
              <v-icon class="mdi-rotate-270">mdi-attachment</v-icon>
            </div>
            <div>
              <div v-for="attachment in todoMapped.attachments" :key="`attachment-${attachment.id}`">
                <p-file-icon :extension="attachment.extension"></p-file-icon>
                <span class="p-link" @click.stop="downloadFile(attachment)">{{attachment.name}}</span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="js-shadow"></div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

import moment from 'moment'

import fileHelper from '@/helpers/file.helper'

import PUserItem from '@/components/PUserItem'
import PBtnIcon from '@/components/PBtnIcon'
import PFileIcon from '@/components/PFileIcon'

import TodoItemActionsMenu from './TodoItemActionsMenu'

import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PUserItem,
    PBtnIcon,
    TodoItemActionsMenu,
    PFileIcon
  },


  mixins: [
    accessMixin
  ],


  props: {
    todo: Object
  },


  data () {
    return {
      dragged: false,
      offsetX: 0,
      offsetY: 0
    }
  },


  computed: {
    ...mapGetters('project', ['shortProjectById']),

    todoMapped () {
      const deadlineFormatted = this.todo.deadline ? moment.utc(this.todo.deadline).format('ll') : null
      const project = this.shortProjectById(this.todo.projectId) || {}

      return {
        ...this.todo,
        project,
        deadlineFormatted
      }
    }
  },


  methods: {
    ...mapActions('todo', ['getAttachment']),

    dragStart (event) {
      const parent = document
      const card = this.$el.getElementsByClassName('js-card')[0]

      parent.onmousemove = (event) => this.mouseMove(event, card)
      parent.onmouseup = (event) => this.dragEnd()
    },

    mouseMove (event, card) {
      if (!this.dragged) {
        const card = this.$el.getElementsByClassName('js-card')[0]
        const shadow = this.$el.getElementsByClassName('js-shadow')[0]

        this.offsetX = event.pageX - card.offsetLeft
        this.offsetY = event.pageY - card.offsetTop + 16

        shadow.style.height = `${card.clientHeight + 2}px`
        card.style.top = `${event.pageY - this.offsetY}px`
        card.style.left = `${event.pageX - this.offsetX}px`
        card.style.width = `${card.clientWidth + 2}px`
        card.style.height = `${card.clientHeight + 2}px`
        card.classList.add('dragged')

        const id = this.todo.id
        const height = card.clientHeight
        this.$emit('dragStarts', { id, height })

        this.dragged = true
      }

      card.style.left = `${event.pageX - this.offsetX}px`
      card.style.top = `${event.pageY - this.offsetY}px`
    },

    dragEnd () {
      this.dragged = false
      const parent = document

      const card = this.$el.getElementsByClassName('js-card')[0]
      const shadow = this.$el.getElementsByClassName('js-shadow')[0]
      card.removeAttribute('style')
      shadow.removeAttribute('style')
      card.classList.remove('dragged')

      this.$emit('dragEnds')
      parent.onmousemove = null
    },

    async downloadFile (attachment) {
      try {
        var response = await this.getAttachment(attachment.id)
        const blob = new Blob([response.data], { type: response.headers['content-type'] })
        fileHelper.downloadFile(blob, attachment.name)
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    }
  }
}
</script>
